module.exports = __webpack_public_path__ + "static/media/ic-message.f7a041ff.svg";